import {
  createFormState,
  required,
  numberGreaterThanOrEqualTo,
} from 'redux-freeform';

const cashDropFormConfig = {
  cashTotal: {
    defaultValue: '0',
    validators: [numberGreaterThanOrEqualTo(0)],
    constraints: [numberGreaterThanOrEqualTo(0)],
  },
  confirmAmounts: {
    defaultValue: false,
    validators: [required()],
  },
  notes: {},
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(cashDropFormConfig);
